function navigation(submenu) {
  const parentMenuItem   = submenu.parentNode;
  const siblingMenuItems = window._farlo.helpers.getSiblings(parentMenuItem);

  const handleKeyDown = (e) => {
    const tag = e.target.tagName.toLowerCase();
    if (tag === 'input' || tag === 'textarea') return;

    const items      = Array.from(parentMenuItem.querySelectorAll('.site-navigation__menu-link'));
    const currentIdx = items.indexOf(document.activeElement);
    let   newIndex;

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        newIndex = (currentIdx + 1) % items.length;
        items[newIndex].focus();
        break;
      case 'ArrowUp':
        e.preventDefault();
        newIndex = (currentIdx - 1 + items.length) % items.length;
        items[newIndex].focus();
        break;
      case 'ArrowRight':
        if (submenu.classList.contains('site-navigation__sub-menu--active')) {
          e.preventDefault();
          submenu.querySelector('.site-navigation__menu-link')?.focus();
        }
        break;
      case 'ArrowLeft':
      case 'Escape':
        e.preventDefault();
        closeMenu(parentMenuItem, submenu);
        parentMenuItem.querySelector('.site-navigation__menu-link')?.focus();
        break;
      case 'Enter':
      case ' ':
        e.preventDefault();
        if (submenu.classList.contains('site-navigation__sub-menu--active')) {
          closeMenu(parentMenuItem, submenu);
        } else {
          openMenu(parentMenuItem, submenu);
          closeAllMenus();
        }
        break;
    }
  };

  const openMenu = (item, menu) => {
    item.classList.add('site-navigation__menu-item--active');
    menu .classList.add('site-navigation__sub-menu--active');
    menu .setAttribute('aria-hidden', 'false');
    item.setAttribute('aria-expanded', 'true');
  };
  const closeMenu = (item, menu) => {
    item.classList.remove('site-navigation__menu-item--active');
    menu .classList.remove('site-navigation__sub-menu--active');
    item.setAttribute('aria-expanded', 'false');
  };
  const closeAllMenus = () => {
    siblingMenuItems.forEach(siblingLi => {
      const sub = siblingLi.querySelector(':scope > .site-navigation__sub-menu');
      if (sub && siblingLi.classList.contains('site-navigation__menu-item--active')) {
        closeMenu(siblingLi, sub);
      }
    });
  };

  submenu.setAttribute('aria-hidden', 'true');
  parentMenuItem.setAttribute('aria-haspopup', 'true');
  parentMenuItem.setAttribute('aria-expanded', 'false');
  submenu.querySelectorAll('.site-navigation__menu-link')
         .forEach(link => link.setAttribute('tabindex', '0'));

  const isTouch     = ('ontouchstart' in window)
                   || navigator.maxTouchPoints > 0
                   || navigator.msMaxTouchPoints > 0;
  const isMobileView = window.innerWidth < 768;

  if (isTouch && isMobileView) {
    const link = parentMenuItem.querySelector(':scope > a');
    if (!link) return;

    const firstSubmenu = document.querySelector('.site-navigation__sub-menu');
    if (submenu === firstSubmenu) {
      openMenu(parentMenuItem, submenu);
    }

    if (parentMenuItem.id === 'menu-item-43') {
      link.addEventListener(
        'click',
        e => e.stopImmediatePropagation(),
        { capture: true }
      );
    } else {
      link.addEventListener('click', e => {
        const isActive = parentMenuItem.classList.contains('site-navigation__menu-item--active');
        if (!isActive) {
          e.preventDefault();
          closeAllMenus();
          openMenu(parentMenuItem, submenu);
        }
      });
    }

    return; 
  }

  parentMenuItem.addEventListener('mouseover', () => {
    closeAllMenus();
    openMenu(parentMenuItem, submenu);
  });
  parentMenuItem.addEventListener('mouseout', () => {
    closeMenu(parentMenuItem, submenu);
  });
  parentMenuItem.addEventListener('keydown', handleKeyDown);
}




function navicon() {
  document.querySelector('.site-navigation__navicon').addEventListener('click', e => {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.classList.toggle('site-navigation__navicon--active');
    document.querySelector('.site-navigation').classList.toggle('site-navigation--active');
    document.body.classList.toggle('site-navigation--open');
    document.body.classList.remove('site-navigation--search');


    const firstItem    = document.querySelector('.site-navigation__sub-menu')?.parentNode;
    const firstSubmenu = firstItem?.querySelector('.site-navigation__sub-menu');
    if (firstItem && firstSubmenu) {
      firstItem.classList.add('site-navigation__menu-item--active');
      firstSubmenu.classList.add('site-navigation__sub-menu--active');
      firstSubmenu.setAttribute('aria-hidden', 'false');
      firstItem.setAttribute('aria-expanded', 'true');
    }
  });
}

function searchIcon() {
	document.querySelector(".site-navigation__search").addEventListener("click", (e) => {
		e.preventDefault();
		e.stopPropagation();
		document.body.classList.remove('site-navigation--open');
		document.body.classList.toggle('site-navigation--search');
	});
	document.querySelector(".site-navigation__search-area-close").addEventListener("click", (e) => {
		document.body.classList.remove('site-navigation--search');

	});
}

export { navigation, navicon, searchIcon };
